import { render, staticRenderFns } from "./CustomerTicket.vue?vue&type=template&id=6328f7a2&scoped=true&"
import script from "./CustomerTicket.vue?vue&type=script&lang=js&"
export * from "./CustomerTicket.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicket.vue?vue&type=style&index=0&id=6328f7a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6328f7a2",
  null
  
)

export default component.exports